import WrapperWhatsapp from 'components/WrapperWhatsapp'
import ScrollToTop from 'hooks/ScrollToTop'
import CannabicastHome from 'pages/CannabicastHome'
import CannectAssistant from 'pages/CannectAssistant'
import CannectEducate from 'pages/CannectEducate'
import ClassesEComposicoes from 'pages/ClassesEComposicoes'
import Community from 'pages/Community'
import CourseLesson from 'pages/CourseLesson'
import ForgotPassword from 'pages/ForgotPassword'
import IntrodutoryCoursesHome from 'pages/IntrodutoryCoursesHome'
import Login from 'pages/Login'
import Prescribers from 'pages/Prescribers'
import PrivacyPolicy from 'pages/PrivacyPolicy'
import QuemSomos from 'pages/QuemSomos'
import Registration from 'pages/Registration'
import RegistrationAssociation from 'pages/RegistrationAssociation'
import ScientificBasesHome from 'pages/ScientificBasesHome'
import SelectWhitepaper from 'pages/SelectWhitepaper'
import TermsOfUse from 'pages/TermsOfUse'
import WebinarsHome from 'pages/WebinarsHome'
import WhitepapersHome from 'pages/WhitepapersHome'
import WorkshopsHome from 'pages/WorkshopsHome'
import { Redirect, Switch } from 'react-router-dom'

import NotFound from 'pages/404'
import BaseRecipe from 'pages/BaseRecipe'
import BaseRecipeBranded from 'pages/BaseRecipeBranded'
import CannectCare from 'pages/CannectCare'
import EcosystemCannect from 'pages/EcosystemCannect'
import NewPassword from 'pages/NewPassword'
import NotAuthorized from 'pages/NotAuthorized'

import { BaseCientifica } from 'components/CannectCienciaComponents/BasesCientificas'
import AccountRecipes from 'pages/AccountRecipes'
import BaseRecipeHelp from 'pages/BaseRecipeHelp'
import BlankRecipeCheckout from 'pages/BlankRecipe'
import HandleRecipeUpload from 'pages/BlankRecipe/Step1'
import SelectProduct from 'pages/BlankRecipe/Step2'
import PersonalDataForm from 'pages/BlankRecipe/Step3'
import ConfirmationDocsUpload from 'pages/BlankRecipe/Step4'
import OrderConfirmation from 'pages/BlankRecipe/Step5'
import Brands from 'pages/Brands'
import BrandsDetails from 'pages/BrandsDetails'
import NewProductSelection from 'pages/CannectAssistant/components/AlreadyKnow/NewProductSelection'
import BasesCientificas from 'pages/CannectCiencia/BasesCientificas'
import Categories from 'pages/NewBlog/Categories'
import SlugPost from 'pages/NewBlog/SlugPost'
import NewCart from 'pages/NewCart'
import NewCartCod from 'pages/NewCartCOD'
import NewCartCodV2 from 'pages/NewCartCOD/v2'
import NewCartDocumentsCOD from 'pages/NewCartDocumetsCOD'
import Treatments from 'pages/Treatments'
import UserPanel from 'pages/UserPanel'
import NewCartCheckout from '../pages/NewCartCheckout'
import SendAnvisaDocument from '../pages/SendAnvisaDocument'
import SendImportDocuments from '../pages/SendImportDocuments'
import SendLaudoMedico from '../pages/SendLaudoMedico'
import SendPrescripitonDoc from '../pages/SendPrescripitonDoc'

import Cobranca from '@cannect/pages/Cobranca'
import ComplementaryPayment from '@cannect/pages/ComplementaryPayment'
import AppointmentScheduling from 'pages/AppointmentScheduling'
import AppointmentSchedulingAspaec from 'pages/AppointmentSchedulingAspaec'
import InstantConsultation from 'pages/InstantConsultation'
import AnalyzeCannectCOD from 'pages/NewCartCOD/AnalyzeCannect/AnalyzeCannect'
import Layout from '../components/Layout'
import Products from '../pages/Products'
import Route from './Route'

import TopMarquee from '@cannect/new-components/TopMarquee'
import { HeaderComponent } from '@cannect/new-components/organisms'
import CalendarioOnboarding from '@cannect/pages/CalendarioOnboarding'
import { CuratorshipPage } from '@cannect/pages/Curatorship'
import { DigitalJourneyPage } from '@cannect/pages/DigitalJourney'
import AnalyzeCannect from '@cannect/pages/NewCart/AnalyzeCannect/AnalyzeCannect'
import NewCartDocuments from '@cannect/pages/NewCartDocumets'
import Nutraceuticos from '@cannect/pages/Nutraceuticos'
import NutraceuticosAnsInso from '@cannect/pages/NutraceuticosAnsInso'
import NutraceuticosInflamatorios from '@cannect/pages/NutraceuticosInflamatorios'
import { ProductDetailsPage } from '@cannect/pages/ProductDetailsV2'
import { RedirectPageProduct } from '@cannect/pages/ProductDetailsV2/redirectPage'
import { WebinarSubscriptionPage } from '@cannect/pages/WebinarSubscription'
import QrCode from 'pages/CannectAssistant/components/EmitRecipe/DigitalSignatureModal/VidaasQrCode/QrCode'
import { Documents } from 'pages/Documents'
import OrderDetails from 'pages/NewCartCOD/OrderDetails'
import ContainerModalAnvisaAndFlowers from '../components/ContainerModalAnvisaAndFlowers'
import Account from '../pages/Account'
import Demand from '../pages/Demand'
import DemandDetails from '../pages/DemandDetails'
import MissingDocuments from '../pages/MissingDocuments'
import ValidateDocuments from '../pages/NewCartDocumets/ValidateDocuments'
import ProductsSupplements from '../pages/ProductsSupplements'
import ShoppingCart from '../pages/ShoppingCart'
import { usePreserveUTM } from './PreserverUTM'
import { RouteDoctor, RoutePatientOrDoctor } from './PrivateRoutes'

import { HeaderAssociationComponent } from '@cannect/new-components/organisms/HeaderAssociation'
import AccountAssociation from '@cannect/pages/AccountAssociations'
import { useBrand } from '../hooks/useBrand'
import LoginAspaec from '../pages/LoginAspaec'
import { BrandProductsList } from '../pages/Marketplace/BrandProductsList'
import { ProductsList } from '../pages/Marketplace/ProductsList'

import { PagaleveSuccess, PagaleveError } from '../pages/Payment/Pagaleve'
import { DigitalJourneyPagaleveReturn } from '@cannect/pages/DigitalJourney/PagaleveReturn'
import CannectCode from 'pages/CannectCode'
import NPS from 'pages/NPS'

const RedirectToProductsList = () => <Redirect to="/produtos/1" />

function Routes() {
  usePreserveUTM()
  const { config } = useBrand()
  const isLoginPage = window.location.pathname === '/areaassociados'
  const isAspaecBrand = config.key === 'aspaec'
  const shouldHideHeader = isLoginPage && isAspaecBrand

  return (
    <>
      {!shouldHideHeader &&
        (config.features.useAssociationHeader ? (
          <HeaderAssociationComponent />
        ) : (
          <>
            <TopMarquee />
            <HeaderComponent />
          </>
        ))}

      <ScrollToTop />
      <ContainerModalAnvisaAndFlowers />
      <Switch>
        {/* Rota de login ASPAEC sem Layout */}
        <Route path="/AreaAssociados" exact component={LoginAspaec} />
        <Route path="/AreaAssociados/MinhaConta" exact component={AccountAssociation} />
        <Route path="/AreaAssociados/MinhaConta/CadastroAssociado" exact component={RegistrationAssociation} />

        <Layout>
          <Route path="/AreaAssociados/detalhes-do-pedido/:cart_id" component={OrderDetails} />
          <Route path="/receitas/:token" exact component={BaseRecipe} />
          <Route path="/receitas/:token/ajuda" exact component={BaseRecipeHelp} />
          {/* Receita whitelabel — o e-mail de receita das marcas aponta para cá */}
          <Route path="/aspaec/receitas/:token" exact component={BaseRecipeBranded} />
          <Route path="/remederi/receitas/:token" exact component={BaseRecipeBranded} />
          <Route path="/vikura/receitas/:token" exact component={BaseRecipeBranded} />
          {/* Cadastro - cada marca tem sua rota específica */}
          <Route path="/cadastro" exact component={Registration} />
          <Route path="/cadastro-associado" exact component={RegistrationAssociation} />
          {/* Login Cannect dentro do Layout */}
          <Route path="/login" component={Login} />
          <Route path="/remederi/login" component={Login} />
          <Route path="/vikura/login" component={Login} />
          <Route path="/blog/:category" exact component={Categories} />
          <Route path="/blog/:category/:slug" component={SlugPost} />
          <Route path="/tratamentos" exact component={Treatments} />
          <Route path="/classes-e-composicoes" exact component={ClassesEComposicoes} />
          <Route path="/comu" exact component={Community} />
          <Route exact path="/termos-de-uso" component={TermsOfUse} />
          <Route exact path="/politica-de-privacidade" component={PrivacyPolicy} />
          <Route exact path="/politica-de-agendamento" component={PrivacyPolicy} />
          <Route exact path="/esqueci-minha-senha" component={ForgotPassword} />
          <Route exact path="/nova-senha" component={NewPassword} />
          <Route exact path="/sobre-nos" component={QuemSomos} />
          <Route exact path="/ecossistema-cannect" component={EcosystemCannect} />

          <Route exact path="/404" component={NotFound} />
          <Route exact path="/nao-autorizado" component={NotAuthorized} />
          <Route path="/whitepapers/:id" component={SelectWhitepaper} />
          <Route path="/profissionais-parceiros-cannabis-medicinal" component={Prescribers} />
          <Route path="/marcas" exact component={Brands} />
          <Route path="/marcas/:brandName" exact component={BrandsDetails} />
          <Route path="/cannect-ciencia" exact component={BasesCientificas} />
          <Route path="/bases-cientificas/:id" component={BaseCientifica} />
          <Route path="/carrinho-wa-novo" component={NewCart} />
          <Route path="/carrinho-wa" component={NewCart} />
          <Route path="/carrinho-wa2" component={NewCartCod} />
          <Route path="/validacao-documentos/:order_id?" component={Documents} />
          <Route path="/documentos-wa" component={NewCartDocuments} />
          <Route path="/documentos-wa2" component={NewCartDocumentsCOD} />
          <Route path="/finalizar-compra-wa/:cart_id" component={NewCartCheckout} />
          <RoutePatientOrDoctor path="/finalizar-compra/:cart_id" component={NewCartCheckout} />
          <Route path="/enviar-receita/:order_id?" component={SendPrescripitonDoc} />
          <Route path="/enviar-documentos/:order_id?" component={SendImportDocuments} />
          <Route path="/autorizacao-anvisa/:order_id?" component={SendAnvisaDocument} />
          <Route path="/laudo-medico/:order_id?" component={SendLaudoMedico} />
          <RoutePatientOrDoctor path="/validate-documentos" component={ValidateDocuments} />
          <Route path="/validate-documentos-wa" component={ValidateDocuments} />
          <Route path="/onboarding-calendar" component={CalendarioOnboarding} />
          <Route path="/analise-cannect-wa" component={AnalyzeCannect} />
          <Route path="/analise-cannect-wa2" component={AnalyzeCannectCOD} />
          <Route path="/pagamento/:type/:order_id/:charge_id" component={Cobranca} />
          <Route path="/pagamento-complementar/:token" component={ComplementaryPayment} />
          <Route path="/pagamento/pagaleve/sucesso" exact component={PagaleveSuccess} />
          <Route path="/pagamento/pagaleve/erro" exact component={PagaleveError} />
          <Route path="/jornada-digital/pagaleve/sucesso" exact component={DigitalJourneyPagaleveReturn} />
          <Route path="/jornada-digital/pagaleve/erro" exact component={DigitalJourneyPagaleveReturn} />
          <Route path="/webinar-inscricao/:webinar_title" component={WebinarSubscriptionPage} />
          <RoutePatientOrDoctor path="/analise-cannect" component={AnalyzeCannectCOD} />
          <Route path="/detalhes-do-pedido/:cart_id" component={OrderDetails} />
          <Route exact path="/agendamento/:cart_id?" component={AppointmentScheduling} />
          <Route exact path="/aspaec/agendamento/:cart_id?" component={AppointmentSchedulingAspaec} />
          <Route exact path="/remederi/agendamento/:cart_id?" component={AppointmentSchedulingAspaec} />
          <Route exact path="/vikura/agendamento/:cart_id?" component={AppointmentSchedulingAspaec} />
          <Route exact path="/consulta-na-hora" component={InstantConsultation} />
          <Route exact path="/remederi/consulta-na-hora" component={InstantConsultation} />
          <Route exact path="/vikura/consulta-na-hora" component={InstantConsultation} />
          <Route exact path="/produtosV1/:pagesProducts" component={Products} />
          <Route exact path="/produtos/:pagesProducts" component={ProductsList} />
          <Route exact path="/produtos-marca/:pagesProducts" component={BrandProductsList} />
          <Route exact path="/produtos" component={RedirectToProductsList} />
          <Route path="/produtos_suplementos/:pagesProducts" exact component={ProductsSupplements} />
          {/* <Route path="/detalhes-produtos/:brand/:name/:id" exact component={ProductDetailsPage} /> */}
          {/* <RoutePatientOrDoctor path="/detalhes-produtos/:brand/:name/:id" exact component={ProductDetailsPage} /> */}
          <Route path="/detalhes-produtos/:id" exact component={RedirectPageProduct} />
          <Route path="/detalhes-produtos/:brand/:name/:id" exact component={ProductDetailsPage} />
          <Route path="/detalhes-produtos_suplementos/:id" exact component={ProductDetailsPage} />
          <RoutePatientOrDoctor path="/painel-do-usuario" component={UserPanel} />
          <RoutePatientOrDoctor path="/assistente" component={CannectAssistant} />
          <Route path="/curadoria" component={CuratorshipPage} />
          <RoutePatientOrDoctor
            exact
            path="/suplementos/protocolo-ansiedade-e-insonia"
            component={NutraceuticosAnsInso}
          />
          <RoutePatientOrDoctor
            exact
            path="/suplementos/protocolo-dor-e-inflamacao"
            component={NutraceuticosInflamatorios}
          />
          <Route exact path="/suplementos" component={Nutraceuticos} />
          <RoutePatientOrDoctor path="/meus-favoritos" component={ShoppingCart} />
          <RoutePatientOrDoctor exact path="/minhas-receitas" component={AccountRecipes} />
          <RoutePatientOrDoctor exact path="/conta" component={Account} />
          <RoutePatientOrDoctor exact path="/pedido" component={Demand} />
          <RoutePatientOrDoctor exact path="/pedido-detalhes" component={DemandDetails} />
          <RoutePatientOrDoctor exact path="/documentos-faltantes" component={MissingDocuments} />
          <RoutePatientOrDoctor path="/cannect-cuida" component={CannectCare} />
          <RoutePatientOrDoctor exact path="/receita-branca/selecao-produtos" component={SelectProduct} />
          <RoutePatientOrDoctor exact path="/receita-branca/endereco-entrega" component={PersonalDataForm} />
          <RoutePatientOrDoctor exact path="/receita-branca/documentos-pessoais" component={ConfirmationDocsUpload} />
          <RoutePatientOrDoctor exact path="/receita-branca/aprovacao-anvisa" component={OrderConfirmation} />
          <RoutePatientOrDoctor exact path="/receita-branca/confirmacao-pedido" component={BlankRecipeCheckout} />
          <RoutePatientOrDoctor path="/carrinho-v1" component={NewCartCod} verifyStatus />
          <RoutePatientOrDoctor path="/carrinho" component={NewCartCodV2} verifyStatus />
          <RoutePatientOrDoctor path="/documentos" component={NewCartDocuments} verifyStatus />
          <RoutePatientOrDoctor
            exact
            path="/receita-branca/inserir-receita"
            verifyStatus
            component={HandleRecipeUpload}
          />
          <RouteDoctor exact path="/educa/cursos-introdutorios" component={IntrodutoryCoursesHome} />
          <RouteDoctor path="/educa/cursos-introdutorios/:id" component={CourseLesson} />
          <RouteDoctor exact path="/educa" component={CannectEducate} />
          <RouteDoctor exact path="/educa/bases-cientificas" component={ScientificBasesHome} />
          <RouteDoctor path="/educa/podcasts" component={CannabicastHome} />
          <RouteDoctor path="/whitepapers" component={WhitepapersHome} />
          <RouteDoctor path="/educa/webnars" component={WebinarsHome} />
          <RouteDoctor path="/educa/workshops" component={WorkshopsHome} />
          <RouteDoctor exact path="/produtos_assistente/:pagesProducts" component={NewProductSelection} />
          <Route path="/sign/qrcode" component={QrCode} />
          {/* Digital Journey */}
          <Route path="/jornada-digital" component={DigitalJourneyPage} />
          {/* NPS público - acesso por token via email */}
          <Route path="/nps/:token" exact component={NPS} />
        </Layout>
      </Switch>
      {config.features.showWhatsapp && <WrapperWhatsapp />}
    </>
  )
}
export default Routes
